export default __webpack_public_path__ + "media/vue/img/btn_google_signin_dark_pressed_web-422875cb120f11c2911a87bf1bbb4160.png";